import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { connect } from "react-redux";
import Header from "../components/Header";
import Masthead from "../components/Masthead";
import Destinations from "../components/Destinations";
import Questions from "../components/Questions";
import Submit from "../components/Submit";
import Thanks from "../components/Thanks";

const Layout = styled.div`
  padding: 0 42px 0;
  @media all and (max-width: 700px) {
    padding: 0;
  }
`;

const Homepage = ({ imgPrefix, lang, submitted, copy }) => (
  <Layout>
    <Header {...{ imgPrefix, copy }} />
    <Masthead {...{ imgPrefix, submitted, copy }} />
    {!submitted && <Destinations {...{ imgPrefix, copy }} />}
    {!submitted && <Questions {...{ lang, copy }} />}
    {!submitted && <Submit {...{ lang, copy }} />}
    {submitted && <Thanks {...{ lang, copy }} />}
  </Layout>
);

Homepage.defaultProps = {
  lang: "en"
};

Homepage.propTypes = {
  copy: PropTypes.objectOf(PropTypes.object).isRequired,
  submitted: PropTypes.bool.isRequired,
  imgPrefix: PropTypes.string.isRequired,
  lang: PropTypes.string
};

const mapStateToProps = state => ({
  ...state.main
});

export default connect(mapStateToProps)(Homepage);
